




import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { isNull, isUndefined } from 'lodash/fp'
import { inject } from 'inversify-props'
import { IDateService } from '@master/services/IDateService'
import { DateTime } from '@master/services/DateTime'

@Component
export default class AppDateInput extends Vue {
  @Prop() readonly value!: number
  @Prop() readonly futureDate: boolean
  @Prop() readonly min: number
  @Prop({ default: 'date' }) readonly inputType: string
  @Prop({ default: false }) readonly disabledFutureDate: boolean

  @inject()
  private dateService: IDateService

  get minDate () {
    if (this.min) return this.dateService.format(this.min, 'YYYY-MM-DD')
    return this.futureDate ? this.dateService.format(new Date(), 'YYYY-MM-DD') : null
  }

  get maxDate () {
    return this.disabledFutureDate ? this.dateService.format(new Date(), 'YYYY-MM-DD') : null
  }

  getDate () {
    if (isUndefined(this.value) || isNull(this.value) || !this.value) return ''
    return this.dateService.format(Number(this.value), this.inputType === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD')
  }

  @Emit('input')
  setDate (e) {
    const dateString = e.target.value
    if (!dateString && !e.target.validity.badInput) {
      return null
    }

    if ((this.min && this.dateService.isInThePastOfDate(dateString, this.min)) || !this.dateService.isValidDate(dateString, 'DD-MM-YYYY')) {
      e.target.value = null
      throw new Error('Please select a valid date!')
    }

    const date = new DateTime(dateString)
    return date.toDate().toString() === 'Invalid Date' ? null : date.time
  }
}
